import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60676243"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "abnormal-order" }

import { ref, onMounted } from 'vue'
import AfterSales from '@/views/usercenter/Order/AbnormalOrder/AfterSales.vue'
import Guide from '@/components/guide/index.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const componentsRef = ref()

onMounted(() => {
  refreshTable()
})

const refreshTable = () => componentsRef.value && componentsRef.value.refreshTable(true)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AfterSales, {
      ref: (_value, _refs) => {
        _refs['componentsRef'] = _value
        componentsRef.value = _value
      }
    }, null, 512),
    _createVNode(Guide, { name: "b2b-after-sale" })
  ]))
}
}

})